import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { ClipLoader } from "react-spinners";
import Popup from "reactjs-popup";

import Logo from "../../Resources/Images/logo.png";
import LogoEsg from "../../Resources/Images/logo_esg.png";
import UsdtLogo from "../../Resources/Images/coin_usdt.png";

import { EthereumIcon, RefreshIcon, LockIcon } from "../Common/Icons";
import globalContext from "../../Hooks/globalContext";
import { numberWithCommas, ToFixed } from "../../Utils/util";
import languagePack from "../../Utils/language";
import Theme from "../../Styles/Theme";
import Axios from "axios";
import { HOST } from "../../Utils/constants";
import useState from "../../Hooks/useState";

const BottomElement = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 80px;
  background-color: white;
`;

const ElementSymbol = styled.div`
  width: 64px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ElementRoot = styled.div`
  display: flex;
  align-items: center;
`;

const ElementTop = styled(ElementRoot)`
  height: 60%;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  color: black;
`;

const ElementBottom = styled(ElementRoot)`
  height: 40%;
  color: ${(props) => props.theme.darkGrey};
  font-size: 12px;
  justify-content: space-between;
  line-height: 16px;
`;

const ElementRight = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: calc(100% - 64px);
  height: 100%;
`;

const SymbolImage = styled.img`
  width: 44px;
`;

const BalanceLabel = styled.div`
  color: ${(props) => props.theme.darkGrey};
  font-size: 13px;
`;

const Label = styled.div`
  display: flex;
  align-items: center;
`;

const Container = ({ price, balance, symbol, fullName, send = false, locked }) => {
  const { getBalance, language, balance: _balance, httpHeader } = useContext(globalContext);

  const onClick = async () => {
    getBalance(symbol);
  };

  const getLocked = async () => {
    const { data } = await Axios.post(`${HOST}/api/lockup`, { tokenType: symbol }, httpHeader());
    locked.setState(Number(data.sum));
  };

  useEffect(() => {
    if (send) {
      if (!balance || balance === ``) {
        const split = symbol.split(" ")[0];
        getBalance(split);
      }
    }
  }, []);

  return (
    <BottomElement>
      <ElementSymbol>
        {symbol === "eth" && <EthereumIcon size={45} />}
        {symbol === "lcms" && <SymbolImage src={Logo} />}
        {symbol === "usdt" && <SymbolImage src={UsdtLogo} />}
        {symbol === "esg" && <SymbolImage src={LogoEsg} />}
      </ElementSymbol>
      <ElementRight>
        <ElementTop>
          <Label>
            <span>{symbol.toUpperCase()}</span>
          </Label>
          {balance !== undefined && !send && <RefreshIcon color={Theme.darkGrey} onClick={onClick} size={18} />}
          {send && <BalanceLabel>{languagePack("잔액", language.state)}</BalanceLabel>}
        </ElementTop>
        <ElementBottom>
          <span>{fullName}</span>
          {balance !== 0 && !balance ? (
            <ClipLoader sizeUnit={"px"} size={15} color={`Theme.lightGrey`} />
          ) : (
            <span>{`${numberWithCommas(Number(balance))} ${symbol.toUpperCase()}`}</span>
          )}
        </ElementBottom>
        <ElementBottom style={{ fontSize: 15, marginTop: 5 }}>
          <span>{price ? `1 ${symbol} : ${ToFixed(Number(price), 10000)}$` : <></>}</span>
          <span>
            {balance >= 0 && price ? `${numberWithCommas(ToFixed(Number(price) * Number(balance)))}$` : <></>}
          </span>
        </ElementBottom>
      </ElementRight>
    </BottomElement>
  );
};

export default Container;
